exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-navigation .main-menu-bar{background-color:#003767}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main/webapp/app/components/main/main.component.css
// module id = 351
// module chunks = 0